jQuery(document).ready(function ($) {
  if ($(".audio-button").length < 1) return;
  var playSrc = $(".audio-button img").attr("src");
  var pauseSrc = $(".audio-pause img").attr("src");
  // click button
  $(".audio-button").click(function () {
    // find linked audio
    var container = $(".audio-button").parents(".audio-container");
    var audio = container.find("audio");

    // is it playing?
    if (container.hasClass("playing")) {
      // if so stop
      audio[0].pause();
      // and change image
      $(container).find(".audio-button img").attr("src", playSrc);
      console.log($(container).find(".audio-button img"));
      container.removeClass("playing");
    } else {
      audio[0].play();
      $(container).find(".audio-button img").attr("src", pauseSrc);
      console.log($(container).find(".audio-button img"));
      container.addClass("playing");
    }
  });
});
